/**
 * Created by r4zi4l on 22.07.2021
 */

const ChestTime = function (mission) {
    this.mission = mission;
};

ChestTime.prototype.canRemoveSilently = function () {
    return true;
};

ChestTime.prototype.getPackCooldownLeft = function () {
    const finishTime = this.mission.details.packCooldown || 0;
    return Math.max(0, finishTime - Date.now());
};

ChestTime.prototype.startPackCooldown = function () {
    this.mission.details.packCooldown = cleverapps.getCooldownStartTime(this.mission.packCooldown) + cleverapps.parseInterval(this.mission.packCooldown);
    this.mission.onChanged();
};
